import {
  Button,
  Col,
  Collapse,
  Divider,
  Empty,
  Form,
  Input,
  InputNumber,
  message,
  Popover,
  Select,
  Space,
  Spin,
} from 'antd'
import styles from './index.module.less'
import { CaretRightOutlined } from '@ant-design/icons'
import { SDrawerOrModal, SGeneralForms, SSegmentedTabs, STitle } from 'shj-components'
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { cloneDeep, isArray } from 'lodash-es'
import {
  changeBaseInfo,
  getCalcQuoteBudgetPrice,
  getCapitalPool,
  getConfigurations,
  quoteBudgetPriceQueryTree,
  refreshQuoteBudgetPrice,
  selectMainSpaceSpec,
} from '@/services/order'
import { useParams } from 'react-router-dom'
import { numFormat } from 'shj-components/dist/es/SFilterTable'
import { OrderEdit } from '@/components/icons'
import PoolingTable from '../../components/PoolingTable'
import { FormOutlined } from '@ant-design/icons'
const { Panel } = Collapse
const classNameObj = {
  工程总造价: 'total-project-cost',
  优惠汇总: 'offer-summary',
  合同金额: 'contract-amount',
  其他收款项目: 'other-income-items',
}

export default forwardRef(function BudgetPrice(props: any, ref) {
  const { couldEdit, quoteBudgetInfo, priceTabList } = props
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [treeData, setTreeData] = useState<any>([])
  const [couldOperate, setCouldOperate] = useState(true)
  const [budgetId, setBudgetId] = useState(useParams()?.budgetId || '')
  const [editFlag, setEditFlag] = useState(false)
  const timeout = useRef<any>(null)
  const [skuArgList, setSkuArgList] = useState<any>([])
  const [form] = Form.useForm()
  // 资金池
  const [poolingOpen, setPoolingOpen] = useState(false)
  const [poolingOpenLoading, setPoolingOpenLoading] = useState(false)
  const [poolingData, setPoolingData] = useState<any>([])
  const [priceTabvalue, setPriceTabvalue] = useState('1')
  const [priceListData, setPriceListData] = useState<any>([])
  const handlebaseInfo = async () => {
    if (quoteBudgetInfo?.skuArgJson) {
      let skuArgList = JSON.parse(quoteBudgetInfo?.skuArgJson || '[]')
      // skuArgList = skuArgList?.filter(item => !item.addFlag)
      console.log(skuArgList, 'skuArgList')

      setSkuArgList(skuArgList)
      let roomNum = 0
      let toiletNum = 0
      skuArgList.forEach((arg: any) => {
        if (arg.argCode === 'BED_ROOM' && Number(arg.argVal) !== NaN) {
          roomNum = Number(arg.argVal)
        }
        if (arg.argCode === 'toilet_num' && Number(arg.argVal) !== NaN) {
          toiletNum = Number(arg.argVal)
        }
      })
      const res = await selectMainSpaceSpec({
        quoteBudgetId: budgetId,
        roomNum,
        toiletNum,
      })
      if (Array.isArray(res)) {
        // setSpaceArgList(res)
        form.setFieldValue('spaceQuoteBudgetItemList', res)
      }
    }
  }
  useEffect(() => {
    handlebaseInfo()
  }, [quoteBudgetInfo])

  useEffect(() => {
    if (open && skuArgList?.length) {
      handlebaseInfo()
    }
    if (!open) {
      form.resetFields()
    }
  }, [open])

  // 1. 初始化
  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    setCouldOperate(couldEdit)
  }, [couldEdit])

  useImperativeHandle(
    ref,
    () => ({
      init: () => init(),
    }),
    []
  )

  const init = (id?: string) => {
    setLoading(true)
    quoteBudgetPriceQueryTree({
      params: {
        quoteBudgetId: id || budgetId,
      },
    })
      .then((res: any) => {
        if (isArray(res)) {
          setTreeData([...res])
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  // 根据id,更新价格
  const updateTreeById = (tree, id, newData) => {
    return tree.map(node => {
      if (node.id === id) {
        return { ...node, object: { ...node.object, ...newData } }
      }
      if (node.children) {
        const updatedChildren = updateTreeById(node.children, id, newData)
        return { ...node, children: updatedChildren }
      }
      return node
    })
  }

  const limitDecimals = value => {
    const reg = /^(\-)*(\d+)\.(\d\d).*$/
    return String(value).replace(reg, '$1$2.$3')
  }

  // 查询价格
  const debouncedSetValue = (treeEntityQuoteBudgetPriceTreeLongs, item) => {
    setLoading(true)
    getCalcQuoteBudgetPrice({
      params: {
        quoteBudgetId: budgetId,
      },
      data: treeEntityQuoteBudgetPriceTreeLongs,
    })
      .then(res => {
        setTreeData(res || [])
      })
      .finally(() => {
        setLoading(false)
      })
  }
  // 改变价格
  const changePrice = (newValue, item) => {
    const valueInput = limitDecimals(newValue)
    const treeEntityQuoteBudgetPriceTreeLongs = updateTreeById(treeData, item.id, {
      price: valueInput || '',
      editedFlag: true,
    })
    setTreeData(treeEntityQuoteBudgetPriceTreeLongs || [])
    if (timeout?.current) {
      clearTimeout(timeout?.current)
    }
    timeout.current = setTimeout(() => {
      debouncedSetValue(treeEntityQuoteBudgetPriceTreeLongs, item)
    }, 1500)
  }
  // 编辑框
  const renderEditInput = it => {
    // editFlag 是否处于编辑状态
    if (validateShowBtnFn(it) && editFlag) {
      return (
        <InputNumber
          step="0.01"
          type="number"
          formatter={limitDecimals}
          parser={limitDecimals}
          onInput={e => {
            changePrice(e, it)
          }}
          size="small"
          value={it?.object?.price}
          prefix="￥"
          style={{ width: 120, height: '30px' }}
          onClick={e => {
            e.stopPropagation()
          }}
        />
      )
    }
    return (
      <div
        className={`${styles.price} ${
          [
            'TOTAL_PROJECT_COST',
            'CONTRACT_AMOUNT',
            'DISCOUNT_SUMMARY',
            'OTHER_PAYMENT_ITEMS',
          ].includes(it?.object?.type)
            ? styles.redPrice
            : ''
        }`}
      >
        ￥{it?.object?.price ? `${numFormat({ value: it?.object?.price })}` : '0.00'}
      </div>
    )
  }
  // 渲染列表
  const renderItem = (item, index) => {
    return (
      <div className={styles.header}>
        <Popover content={item?.object?.name} placement="topLeft">
          <div className={styles.label}>
            {item.parentId !== '0' && <span className={styles.numberIndex}>{index + 1}</span>}
            {item?.object?.name}
          </div>
        </Popover>
        {renderEditInput(item)}
      </div>
    )
  }
  // 验证是否可编辑
  const validateShowBtnFn = node =>
    (node?.object?.mathType === 'CREATOR_ENTRY' || node?.object?.editFlag) && couldOperate

  // 验证
  const isEmpty = value => {
    return value === null || value === undefined || value === ''
  }
  // 验证未填写
  const validateFn = node => validateShowBtnFn(node) && isEmpty(node?.object?.price)
  const validateTree = (tree, validateFn) => {
    for (const node of tree) {
      if (validateFn(node)) {
        return {
          label: node?.label,
          status: false,
        } // 如果验证失败，返回false
      }
      if (node.children && node.children.length > 0) {
        const result = validateTree(node.children, validateFn).status
        if (!result) {
          return {
            label: node?.label,
            status: false,
          } // 如果子节点验证失败，返回false
        }
      }
    }
    return {
      label: '',
      status: true,
    } // 所有节点验证通过，返回true
  }
  // 点击保存
  const saveFn = () => {
    if (!validateTree(treeData, validateFn).status) {
      return message.error(`请填写${validateTree(treeData, validateFn)?.label}！`)
    }
    setLoading(true)
    refreshQuoteBudgetPrice({
      params: {
        quoteBudgetId: budgetId,
      },
      data: treeData,
    })
      .then(() => {
        init()
        setEditFlag(false)
        // props?.onCancel && props?.onCancel()
        props?.reloadList && props?.reloadList()
      })
      .finally(() => {
        setLoading(false)
      })
  }
  const renderTreeComponent = (treeData, level) => {
    return (
      <div>
        {(treeData || []).map((item, index) => {
          if ((item?.children || []).length === 0) {
            return (
              <>
                <div
                  className={`${styles.noSubHeader} ${level === 0 ? styles.levelFirst : ''}  ${
                    level === 0 && classNameObj[item.label] ? classNameObj[item.label] : ''
                  } 
                  ${!item.object.type ? 'normalFee' : ''} `}
                  key={item?.id}
                >
                  {renderItem(item, index)}
                </div>
              </>
            )
          }
          return (
            <Collapse
              ghost
              defaultActiveKey={['1']}
              expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
              className={`${classNameObj[item.label] ? classNameObj[item.label] : ''}  ${
                !item.object.type ? 'normalFee' : ''
              } `}
            >
              <Panel
                header={
                  <div className={`${level === 0 ? styles.levelFirst : ''}  `}>
                    {renderItem(item, index)}
                  </div>
                }
                key={'1'}
              >
                {renderTreeComponent(item?.children, level + 1)}
              </Panel>
            </Collapse>
          )
        })}
      </div>
    )
  }

  const clickToEdit = () => {
    console.log('clickToEdit')
    setEditFlag(true)
    renderTreeComponent(treeData, 0)
  }
  const clickToGetPoolingTable = () => {
    setPoolingOpen(true)
    setPoolingOpenLoading(true)
    getCapitalPool(budgetId)
      .then((res: any) => {
        setPoolingData(res)
      })
      .finally(() => {
        setPoolingOpenLoading(false)
      })
  }
  const priceTabListChange = value => {
    setPriceTabvalue(value)
    if (value === '2') {
      // 获取清单数据
      getConfigurations(budgetId).then(res => {
        console.log(res, '清单数据')
        if (res && Array.isArray(res)) {
          setPriceListData(res)
        }
      })
    }
  }
  return (
    <div className={styles.budgetPriceBox}>
      <div className={styles.priceBox}>
        {/* 预算信息 */}
        {(treeData || []).length > 0 ? (
          <div className={styles.priceDetailBox}>
            <div className={styles.priceTabBox}>
              <p style={{ fontWeight: 600 }}>报价费用</p>
              <div className={styles.modifyBtnBox}>
                {editFlag ? (
                  <div className={styles.btnBox}>
                    <Button type="primary" onClick={saveFn} style={{ marginRight: 10 }}>
                      确定
                    </Button>
                    <Button
                      onClick={() => {
                        setEditFlag(false)
                        // props?.onCancel()
                      }}
                    >
                      取消
                    </Button>
                  </div>
                ) : (
                  <Button
                    onClick={clickToEdit}
                    disabled={
                      !(quoteBudgetInfo?.state === 'budgetDraft' && !quoteBudgetInfo?.frozenFlag)
                    }
                    type="primary"
                  >
                    编辑金额
                  </Button>
                )}
              </div>
            </div>
            <div className={styles.priceList}>{renderTreeComponent(treeData, 0)}</div>
          </div>
        ) : (
          <div className={styles.priceDetailPopover}>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </div>
        )}
      </div>
      <SDrawerOrModal
        mode="drawer"
        title="资金池详情"
        open={poolingOpen}
        loading={poolingOpenLoading}
        onCancel={() => setPoolingOpen(false)}
        // styles={{ body: { padding: '0 15px' } }}
        width={800}
        antdProps={{
          destroyOnClose: true,
          footer: null,
        }}
      >
        <PoolingTable data={poolingData}></PoolingTable>
      </SDrawerOrModal>
    </div>
  )
})
